import { EMPTY_LIST, EMPTY_OBJECT } from '../../../constants/common'
import { FieldStackedLabel } from '../../Field'
import { FormFieldSelectNG } from '../../Form'
import { FormikField, getFormikFormFieldErrorProps } from '../../Formik'
import { LabelMultiSelect } from '../LabelMultiSelect'

function LabelFormField({
  controlProps = EMPTY_OBJECT,
  disabled = false,
  entity,
  fieldComponentProps = EMPTY_OBJECT,
  getErrorProps = getFormikFormFieldErrorProps,
  name,
  placeholder,
  ...restProps
}) {
  return (
    <FormikField
      {...restProps}
      multi
      Component={FormFieldSelectNG}
      Field={FieldStackedLabel}
      Select={LabelMultiSelect}
      controlProps={{
        ...controlProps,
        contentProps: {
          ...controlProps?.contentProps,
          inputProps: {
            ...controlProps?.contentProps?.inputProps,
            placeholder,
          },
        },
      }}
      disabled={disabled}
      emptyValue={EMPTY_LIST}
      entity={entity}
      fieldComponentProps={fieldComponentProps}
      getErrorProps={getErrorProps}
      name={name}
    />
  )
}

export default LabelFormField
